var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "mail_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    className: "mail_svg__Platform=Mail, mail_svg__Coloured=No, mail_svg__State=Default"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mail_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    className: "mail_svg__a",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z",
    className: "mail_svg__Bounding mail_svg__box"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mail_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 20q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 18V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4h16q.824 0 1.413.588Q22 5.175 22 6v12q0 .824-.587 1.413A1.93 1.93 0 0 1 20 20zm8-7 8-5V6l-8 5-8-5v2z",
    className: "mail_svg__mail"
  })))));
};
export { SvgMail as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIiByb2xlPSJpbWciPjx0aXRsZT5NYWlsPC90aXRsZT48ZyBjbGFzcz0iUGxhdGZvcm09TWFpbCwgQ29sb3VyZWQ9Tm8sIFN0YXRlPURlZmF1bHQiPjxtYXNrIGlkPSJhIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHg9IjAiIHk9IjAiIGNsYXNzPSJhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBzdHlsZT0ibWFzay10eXBlOmFscGhhIj48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0wIDBoMjR2MjRIMHoiIGNsYXNzPSJCb3VuZGluZyBib3giLz48L21hc2s+PGcgbWFzaz0idXJsKCNhKSI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNNCAyMGMtLjU1IDAtMS4wMi0uMTk2LTEuNDEzLS41ODdBMS45MjYgMS45MjYgMCAwIDEgMiAxOFY2YzAtLjU1LjE5Ni0xLjAyLjU4Ny0xLjQxMkExLjkyNiAxLjkyNiAwIDAgMSA0IDRoMTZjLjU1IDAgMS4wMi4xOTYgMS40MTMuNTg4LjM5MS4zOTEuNTg3Ljg2Mi41ODcgMS40MTJ2MTJjMCAuNTUtLjE5NiAxLjAyLS41ODcgMS40MTNBMS45MjYgMS45MjYgMCAwIDEgMjAgMjBINFptOC03IDgtNVY2bC04IDUtOC01djJsOCA1WiIgY2xhc3M9Im1haWwiLz48L2c+PC9nPjwvc3ZnPg==";